import { ArrowRight, ArrowDown } from "@phosphor-icons/react";
import { useApkDownload } from "@/lib/useApkDownload";

export default function StickyCTA() {
  const { downloading, start } = useApkDownload();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[65] border-t border-line bg-night/90 px-4 py-3 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
      data-testid="sticky-bottom-cta"
    >
      <div className="mx-auto flex max-w-md gap-2.5">
        <a
          href="/login"
          data-testid="sticky-get-started-button"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-brand-500 to-brand-600 py-3 text-sm font-semibold text-white shadow-lg shadow-brand-500/25"
        >
          Get Started <ArrowRight size={15} weight="bold" />
        </a>
        <button
          onClick={start}
          disabled={downloading}
          data-testid="sticky-download-button"
          className="flex items-center justify-center gap-2 rounded-full border border-line px-5 py-3 text-sm font-semibold text-paper/85 disabled:opacity-70"
        >
          <ArrowDown size={15} weight="bold" />
          {downloading ? "..." : "App"}
        </button>
      </div>
    </div>
  );
}
